import React from 'react';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import EarndedPoints from '../../assets/images/MyPoints/EarnedPoints.png';
import Redeem from '../../assets/images/MyPoints/Redeem.png';
import { ActionCardInsidewig } from '../Atoms/ActionCardInsidewig';
import { useTranslation } from 'react-i18next';

interface RewardsProps {
  visible: boolean;
  onClose: () => void;
}

const MyPoints: React.FC<RewardsProps> = ({ visible, onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCardClick = (title: string) => {
    if (title === 'Widget') {
      navigate('/points');
      onClose(); // Close the modal after navigation
    } else {
      if (title === 'Redeem Points') {
        //uat
        // window.location.href = 'https://aptean.vantagecircle.co.in/'; // External navigation
        //prod
        window.open('https://aptean.vantagecircle.com/', '_blank');
      }
    }
  };
  const PointsHistory = () => {
    return (
      <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center">
        <img src={EarndedPoints} alt="Pat on the Back" className="w-14 h-8 object-contain" />
      </div>
    );
  };
  const Redemption = () => {
    return (
      <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center">
        <img src={Redeem} alt="Pat on the Back" className="w-14 h-8 object-contain" />
      </div>
    );
  };

  const renderCardContent = () => (
    <div style={{ height: 'auto' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '16px',
          padding: '20px 0 20px',
        }}
      >
        {/* Card 1: Widget */}
        <div
          onClick={() => handleCardClick('Widget')}
          style={{
            position: 'relative',
            cursor: 'pointer',
            width: '185px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '185px',
              height: '185px',
              backgroundColor: '#B3E5FC',
              borderRadius: '18px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #87DEEB',
              marginBottom: '16px',
            }}
          >
            <ActionCardInsidewig
              icon={PointsHistory()}
              title={t('earned_points')}
              message=""
              background="#68C4D8"
              border="1px solid #68C4D8"
              variant="default"
            />
          </div>
        </div>

        {/* Card 2: Disabled */}
        <div
          onClick={() => handleCardClick('Redeem Points')}
          style={{
            position: 'relative',
            cursor: 'pointer',
            width: '185px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '185px',
              height: '185px',
              backgroundColor: '#B3E5FC',
              borderRadius: '18px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #87DEEB',
              marginBottom: '16px',
            }}
          >
            <ActionCardInsidewig
              icon={Redemption()}
              title={t('redeem_points')}
              message={<div></div>} 
              background="#68C4D8"
              border="1px solid #D1D5DB"
              variant="default"
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      title={
        <div
          style={{
            fontSize: '20px',
            fontWeight: 600,
            color: '#111827',
            padding: '8px 0',
          }}
        >
          {t('my_points')}
        </div>
      }
      visible={visible}
      onCancel={onClose} // Close the modal when the cancel button is clicked
      footer={null}
      centered
      width={750}
      bodyStyle={{ padding: '24px 32px 10px' }}
    >
      {renderCardContent()}
    </Modal>
  );
};

export default MyPoints;